import React from "react";

const LeftArrow = ({ className, id, title }) => (
  <svg className={className} viewBox="0 0 16 16" fill="none">
    <title>{title}</title>
    <path
      fill="currentColor"
      d="M8.36768544,0.297400544 L8.44542118,0.366502052 L16,7.92108088 L8.29972433,15.6213565 C7.94532893,15.9757519 7.37617635,15.9811878 7.02848646,15.6334979 C6.70563156,15.3106431 6.68725757,14.7968331 6.97002872,14.4413301 L7.04062786,14.3622601 L12.403,8.99924951 L0.867295402,9 C0.388301378,9 0,8.55228475 0,8 C0,7.48716416 0.334810882,7.06449284 0.766150436,7.00672773 L0.867295402,7 L12.511,6.99924951 L7.1620419,1.64988133 C6.839187,1.32702643 6.82081301,0.813216457 7.10358416,0.457713455 L7.1741833,0.378643455 C7.50326475,0.0495620109 8.01751947,0.0213691236 8.36768544,0.297400544 Z"
      transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
    ></path>
  </svg>
);

export default LeftArrow;
